import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Risk';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.3586 3.36127C10.4945 3.13699 10.7377 3 11 3H17.25C17.5304 3 17.7874 3.15642 17.9162 3.4055C18.045 3.65457 18.0241 3.95469 17.862 4.18351L14.4503 9H18C18.3033 9 18.5768 9.18273 18.6929 9.46299C18.809 9.74324 18.7448 10.0658 18.5303 10.2803L8.03033 20.7803C7.77647 21.0342 7.37832 21.0725 7.08067 20.8718C6.78302 20.6711 6.66935 20.2876 6.80956 19.9571L9.86712 12.75H6C5.7292 12.75 5.47943 12.604 5.34653 12.3681C5.21363 12.1321 5.21825 11.8429 5.3586 11.6113L10.3586 3.36127ZM11.4224 4.5L7.33154 11.25H11C11.2516 11.25 11.4865 11.3762 11.6254 11.586C11.7643 11.7958 11.7887 12.0613 11.6904 12.2929L9.69655 16.9928L16.1893 10.5H13C12.7196 10.5 12.4626 10.3436 12.3338 10.0945C12.205 9.84543 12.2259 9.54531 12.388 9.31649L15.7997 4.5H11.4224Z" fill="currentColor"/>
  </svg>
`;

const RiskIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.3586 3.36127C10.4945 3.13699 10.7377 3 11 3H17.25C17.5304 3 17.7874 3.15642 17.9162 3.4055C18.045 3.65457 18.0241 3.95469 17.862 4.18351L14.4503 9H18C18.3033 9 18.5768 9.18273 18.6929 9.46299C18.809 9.74324 18.7448 10.0658 18.5303 10.2803L8.03033 20.7803C7.77647 21.0342 7.37832 21.0725 7.08067 20.8718C6.78302 20.6711 6.66935 20.2876 6.80956 19.9571L9.86712 12.75H6C5.7292 12.75 5.47943 12.604 5.34653 12.3681C5.21363 12.1321 5.21825 11.8429 5.3586 11.6113L10.3586 3.36127ZM11.4224 4.5L7.33154 11.25H11C11.2516 11.25 11.4865 11.3762 11.6254 11.586C11.7643 11.7958 11.7887 12.0613 11.6904 12.2929L9.69655 16.9928L16.1893 10.5H13C12.7196 10.5 12.4626 10.3436 12.3338 10.0945C12.205 9.84543 12.2259 9.54531 12.388 9.31649L15.7997 4.5H11.4224Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: RiskIcon,
  IconSvg: IconSvg
} as IconType;
